import { useEffect, useState } from "react";
import { api } from "../lib/api";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function LegalPage({ pageKey, testId }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/page/${pageKey}`).then((r) => setD(r.data)).catch(() => setD({ title: "", content: "" })); }, [pageKey]);
  if (!d) return <div className="h-screen flex items-center justify-center text-[#6B7280]">Caricamento…</div>;
  return (
    <div data-testid={testId} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 prose-betelgez">
      <h1>{d.title}</h1>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{d.content || ""}</ReactMarkdown>
    </div>
  );
}

export const Privacy = () => <LegalPage pageKey="privacy" testId="page-privacy" />;
export const Cookie = () => <LegalPage pageKey="cookie" testId="page-cookie" />;
